<template>
  <div class="col-xs p0">
    <div class="best-seller item-label c-bg-red c-white align-center justify-center flex fs12 lh15 ml45 pt20 pb6 relative">
      <div class="text-wrapper c-bg-red flex flex-row align-items-center w-100">
        <span class="pr3">
          {{ maxQuantity }}
        </span>
        <span class="tickets-left-label">
          {{ $t(maxQuantity === 1 ? 'ticket left' : 'tickets left') }}
        </span>
        <tooltip
          :title="$t('Availability on our website')"
          :text="$t('This is the quantity of tickets currently available to purchase for this event on our website.')"
          icon="icon-ev-warning-white"
          active-icon="icon-ev-warning-white"
          class="hidden-mobile"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Tooltip from 'theme/components/common/Tooltip.vue'

export default {
  name: 'TicketsLeft',
  components: {
    Tooltip
  },
  props: {
    maxQuantity: {
      type: Number,
      required: true
    },
    productSku: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getConfigs: 'magentoConfig/getValue'
    })
  },
  methods: {
    showTicketsLeftPopupWindow () {
      this.$store.commit('ui/setShowTicketsLeftPopup', this.productSku)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/variables/grid';
@import '~theme/css/helpers/functions/z-index-selectors';

.item-label {
  position: absolute;
  border-radius: 4px 0 0 4px;
  min-width: 101px;
  height: 23px;
  padding: 0;
  right: -5px;
  bottom: 30px;
  text-align: left;
  z-index: zIndex(banner);

  .text-wrapper {
    justify-content: flex-end;
    padding: 3px 7px;
    z-index: zIndex(banner);
    border-radius: 4px 0 0 4px;

    .tickets-left-label {
      padding-right: 6px;
    }

  }

  &::after {
    content: '';
    position: absolute;
    background-color: #7d0009;
    z-index: zIndex(header);
    bottom: -2px;
    right: 0;
    width: 5px;
    height: 20px;
    transform: skewY(316deg);
  }
}

/deep/ .icon-ev-warning-white {
  height: 11px;
  width: 11px;
}

@include mediaQuery(sm) {
  .item-label {
    min-width: 104px;
    height: 21px;
    bottom: 63px;
    right: -7px;

    .text-wrapper {
      .tickets-left-label {
        padding-right: 10px;
      }
    }

    &::after {
      bottom: -3px;
      width: 7px;
    }
  }
}
</style>
